import { toast } from "react-toastify";
import userManager from "./ducks/authentication/userManager";
import { UDM_AUTH_STATE_LS_ID } from "./ducks/authentication/reducers";

export default async function checkForUpdate() {
  const res = await fetch(`${process.env.PUBLIC_URL}/version.json`, {
    cache: "no-cache",
  });
  const { version } = await res.json();
  if (version !== localStorage.getItem("appVersion")) {
    localStorage.setItem("appVersion", version);
    const user = await userManager.getUser();
    if (user) {
      toast.info(
        "New application version available. Logging out to update...",
        {
          onClose() {
            sessionStorage.removeItem(UDM_AUTH_STATE_LS_ID);
            userManager.signoutRedirect();
          },
        }
      );
    }
  }
}
